"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M1,1.00247329 C1,0.448822582 1.4556644,0 1.99539757,0 L10.0046024,0 C10.5543453,0 11,0.455760956 11,1.00247329 L11,10.9975267 C11,11.5511774 10.5443356,12 10.0046024,12 L1.99539757,12 C1.44565467,12 1,11.544239 1,10.9975267 L1,1.00247329 Z M3,2 L9,2 L9,9 L3,9 L3,2 Z M5,10 L7,10 L7,11 L5,11 L5,10 Z"
  }));
};

exports["default"] = _default;